import React from "react";
// Component
import MainTable from '../../Components/Tables/Main/MainTable'
import ButtonSwitchBetweenTables from '../../Components/Buttons/ButtonSwitchBetweenTables'
// Hook
import { useVehicles } from "../../Hooks/useVehicles";
// Library
import AddBox from '@material-ui/icons/AddBox';
import { useHistory } from "react-router-dom";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// Constants
import { deregisterVehicleTypes, resolveTimezoneOffsetError } from "../../CommonConstants"
import { columns, actions, requiredFields, deleteText } from "./VehicleReusableConstants"
import { cloneDeep } from 'lodash';
const editedColumns = cloneDeep(columns)
editedColumns.forEach(column => column.editable = 'never')

const Vehicles = () => {
    const [vehiclesData, , , , , reregisterVehicle, editDeregister] = useVehicles(false);

    const history = useHistory();

    const navigateToActiveVehicles = () => history.push('/vehicles/active')

    const allActions = [{
        icon: AddBox,
        tooltip: "Activar",
        onClick: async (event, rowData) => {
            await reregisterVehicle(rowData.deregisterId)
            navigateToActiveVehicles()
        },
    }, ...(actions(history))];

    const allColumns = [
        ...editedColumns,
        { title: "Tipo de baja", field: "deregisterType", lookup: deregisterVehicleTypes },
        { title: "Descripción", field: "description" },
        {
            title: "Fecha de baja",
            field: "deregisterDate",
            type: "date",
            render: row => row.deregisterDate ? <span>{resolveTimezoneOffsetError(row.deregisterDate, 'dd/MM/yyyy')}</span> : <span></span>,
            editComponent: props => (
                <MuiPickersUtilsProvider utils={DateFnsUtils}
                    locale={props.dateTimePickerLocalization}>
                    <DatePicker
                        format="dd/MM/yyyy"
                        value={props.value ? resolveTimezoneOffsetError(props.value) : null}
                        onChange={props.onChange}
                        clearable
                        InputProps={{
                            style: {
                                fontSize: 13,
                            }
                        }}
                    />
                </MuiPickersUtilsProvider>
            )
        }
    ]

    return (
        <div>
            <ButtonSwitchBetweenTables text={'Ver vehículos activos'} onClick={navigateToActiveVehicles} />
            <MainTable
                {...{ deleteText, requiredFields }}
                title="Vehículos inactivos"
                actions={allActions}
                data={vehiclesData}
                columns={allColumns}
                onRowAdd={() => null}
                onRowUpdate={async ({ deregisterId, description, deregisterType, deregisterDate }) => {
                    const dataToSave = {
                        description,
                        deregisterType,
                        deregisterDate: deregisterDate ? resolveTimezoneOffsetError(deregisterDate, "yyyy-MM-dd") : null
                    }
                    await editDeregister(dataToSave, deregisterId)
                }}
                onRowDelete={() => null}
                isAddAllowed={false}
                isDeleteAllowed={false}
            />
        </div>)
}

export default Vehicles


// WEBPACK FOOTER //
// ./src/Containers/Vehicles/InactiveVehicles.js